import { GetStaticProps, NextPage } from 'next'
import dynamic from 'next/dynamic'
import React /*, { useEffect, useState }*/ from 'react'
import { Footer } from 'src/components/Footer/Footer'
// import HomeBuyVendorBadge from 'src/components/global/HomeBuyVendorBadge/HomeBuyVendorBadge'
import { HtmlContentViewer } from 'src/components/global/HtmlContentViewer/HtmlContentViewer'
import { ThemeOnly } from 'src/components/global/ThemeOnly'
import { THEME } from 'src/config/config'
import { apolloSdk } from 'src/graphql/apolloSdk'
import { IPrivacyPolicy } from 'src/graphql/generated/hooks'
import { Meta } from 'src/layout/Meta'
import { Main } from 'src/templates/Main'

const HomeBuyVendorBadge = dynamic(
  () => import('src/components/global/HomeBuyVendorBadge/HomeBuyVendorBadge').then((mod) => mod.default),
  {
    ssr: false, // Client-side only
    loading: () => <p className="loading-placeholder"></p>,
  },
)

type Props = {
  privacyPolicy: IPrivacyPolicy
  dateStr: string
}

const PrivacyPolicyPage: NextPage<Props> = ({ privacyPolicy, dateStr }: Props) => {
  const meta = <Meta title="Privacy Policy" description="Privacy Policy" url="/privacy-policy/" />

  // const [minHeight, setMinHeight] = useState(0)

  // useEffect(() => {
  //   // window is accessible here.
  //   const innerHegiht = window.innerHeight
  //   const minHeight = innerHegiht - 590
  //   setMinHeight(minHeight)
  // }, [])

  return (
    <Main meta={meta}>
      <div id="mainContainer" className="policy-container">
        <div className="flex flex-col bg-clouds">
          {privacyPolicy && (
            <div className="flex flex-row justify-center bg-clouds">
              <div className="pl-[1.25rem] pr-[1.25rem] !max-w-[1100px] w-full flex flex-col py-2">
                <span className="text-darkgray font-primary font-regular text-[13px] tracking-normal cursor-pointer py-6">
                  {dateStr?.toUpperCase()}
                </span>
                <HomeBuyVendorBadge />
                <div className="sm:grid-cols-2">
                  <div className="self-center">
                    <h1 className="pt-[0.5rem] pb-[0.625rem] text-[30px] font-bold font-secondary text-darkgray">
                      Privacy Policy
                    </h1>
                    <h3 className="terms-content text-[1.125rem] font-primary font-regular text-darkgray mb-8">
                      <HtmlContentViewer html={privacyPolicy?.summary || ''} />
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <hr />

        <div className="flex flex-row justify-center w-full min-h-[calc(100vh-590px)]">
          <div className="!max-w-[1100px] w-full mb-32 font-primary font-regular text-darkgray text-[16px] md:pr-[14.5rem] pl-[1.25rem] pr-[1.25rem]">
            {privacyPolicy && <HtmlContentViewer className="terms-content" html={privacyPolicy?.content || ''} />}
          </div>
        </div>

        <ThemeOnly theme="legaltech">
          <Footer />
        </ThemeOnly>
      </div>
    </Main>
  )
}

export default PrivacyPolicyPage

export const getStaticProps: GetStaticProps = async ({}) => {
  if (THEME === 'ilta')
    return {
      revalidate: 60,
      notFound: true,
    }

  const { privacyPolicy } = await apolloSdk.getPrivacyPolicy()

  const data = privacyPolicy
  const date = data?.date ? new Date(data.date) : null
  // const dateStr = date
  //   ? 'UPDATED ON ' +
  //     date.toLocaleString('default', { month: 'long' }) +
  //     ' ' +
  //     date.getDay().toString() +
  //     ', ' +
  //     date.getFullYear().toString()
  //   : ''
  const dateStr = date
    ? `UPDATED ON ${date.toLocaleString('default', { month: 'long' })} ${date.getDate().toString()}, ${date.getFullYear().toString()}`
    : ''

  return {
    props: {
      privacyPolicy: data,
      dateStr,
    },
    revalidate: 60,
  }
}
